/* Redux, Thunk & Root Reducer Imports */
import thunk from 'redux-thunk'
import createDebounce from 'redux-debounced'
import { configureStore } from '@reduxjs/toolkit'
import loadingSpinnerMiddleware from '../middleware/loadingSpinnerMiddleware'

/* Own */
import rootReducer from '../reducers/rootReducer'

/* Init middleware */
const middleware = [thunk, loadingSpinnerMiddleware, createDebounce()]

/* Create store */
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export { store }
